/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachineGroups/Components/AddVirtualMachinesComponent" />
import * as React from "react";

import { ActionCreatorManager } from "Environments/Flux/ActionCreatorManager";
import { AddVirtualMachinesDetailsComponent } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Components/AddVirtualMachinesDetailsComponent"
import { EnvironmentBaseComponent, IEnvironmentBaseComponentState } from "Environments/EnvironmentsCommon/EnvironmentBaseComponent";
import { IResourceContributionProps, ResourceSectionTypes, IResourceCreatedResponse } from "Environments/EnvironmentsCommon/Utils";
import { IVirtualMachinesProviderData } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Utilities";
import { VirtualMachineGroupCreateActionCreator } from "Environments/ProviderCreateDetails/VirtualMachineGroups/ActionsCreators/VirtualMachineGroupCreateActionCreator";
import { VirtualMachineGroupCreateStore } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Stores/VirtualMachineGroupCreateStore";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { StoreManager } from "Environments/Flux/StoreManager";

import { PageTitle } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Resources";

interface IAddVirtualMachinesState extends IEnvironmentBaseComponentState {
    providerData: IVirtualMachinesProviderData;
}

export class AddVirtualMachinesComponent extends EnvironmentBaseComponent<IResourceContributionProps, IAddVirtualMachinesState> {

    public getInstanceId(context: IVssComponentContext): string {
        return "add-virtual-machines-instance-id";
    }

    constructor(props: IResourceContributionProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {
            providerData: { name: "" },
            errorMessages: {}
        };

        this._vmResourceActionCreator = ActionCreatorManager.CreateActionCreator<VirtualMachineGroupCreateActionCreator>(VirtualMachineGroupCreateActionCreator, this._instanceId);
        this._vmResourceStore = StoreManager.CreateStore<VirtualMachineGroupCreateStore>(VirtualMachineGroupCreateStore, this._instanceId);

        this._vmResourceStore.addChangedListener(this._onVirtualMachinesResourceStoreChange);
    }

    public render(): JSX.Element {
        return (
            <>
                <h2 className={this.props.headerClassName}>{PageTitle}</h2>
                <AddVirtualMachinesDetailsComponent
                    instanceId={this._instanceId}
                    providerData={this.state.providerData}
                    onProviderDataChange={this._onVirtualMachinesProviderDataChange}
                />
            </>
        );
    }

    public componentDidUpdate(prevProps: IResourceContributionProps) {
        if (this.props.environmentId && this.props.createResourceSignal && prevProps.createResourceSignal !== this.props.createResourceSignal) {
            this._vmResourceActionCreator.createResource(this.context.pageContext, this.state.providerData, this.props.environmentId, this.props.onResourceCreated);
        }
    }

    public componentWillUnmount(): void {
        this._vmResourceStore.removeChangedListener(this._onVirtualMachinesResourceStoreChange);

        StoreManager.DeleteStore<VirtualMachineGroupCreateStore>(VirtualMachineGroupCreateStore, this._instanceId);
        ActionCreatorManager.DeleteActionCreator<VirtualMachineGroupCreateActionCreator>(VirtualMachineGroupCreateActionCreator, this.props.instanceId);
    }

    private _onVirtualMachinesProviderDataChange = (data: IVirtualMachinesProviderData, isValid: boolean) => {
        this.setState({ providerData: data });
        this.props.footerButtonCallbacks.onCreateButtonStatusUpdate(!isValid);
    }

    private _onVirtualMachinesResourceStoreChange = (): void => {
        this.props.onResourceCreated.onSuccess(this._vmResourceStore.getState().resource);
    }

    private _vmResourceActionCreator: VirtualMachineGroupCreateActionCreator;
    private _vmResourceStore: VirtualMachineGroupCreateStore;
}

VssComponent.register(ResourceSectionTypes.VmProvider, AddVirtualMachinesComponent);
